import {
  UPDATE_GROUP_BY_OPTION,
  TOGGLE_SHOW_SNOOZED,
  UPDATE_SORT_BY_OPTION,
} from "./actionTypes";

export const updateGroupByOption = (groupByOption) => ({
  type: UPDATE_GROUP_BY_OPTION,
  groupByOption,
});
export const updateSortByOption = (sortByOption) => ({
  type: UPDATE_SORT_BY_OPTION,
  sortByOption,
});
export const toggleShowSnoozed = () => ({ type: TOGGLE_SHOW_SNOOZED });
